import { Component, OnInit } from '@angular/core';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TariffService } from 'src/app/Service/Tariff/Tariff.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-TariffHistory',
  templateUrl: './TariffHistory.component.html',
  styleUrls: ['./TariffHistory.component.scss']
})
export class TariffHistoryComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  BaseURL=environment.BaseUrl+"file/Tariff/"

  constructor(
    private Tarrif_Service:TariffService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
  ) { }


  DataList_Tarrif:Array<General_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1137).subscribe(
      data=>{
        this.ReadData_Tarrif()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Tarrif(){
    this.Procssing=true
    this.Tarrif_Service.GetHistoryFile().subscribe(
      data=>{
        this.DataList_Tarrif=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

}
